module.exports = __webpack_public_path__ + "media/components/assets/img/icons/airplane-avatar-64677a9dda3693b36fc3cf471fd66b6a.svg";